module.exports = __webpack_public_path__ + "img/Picture35.2dade5e7.png";